import { InputNumber } from 'antd';
import withRepeater from './withRepeater'

SequencedFormNumericInput = ({ form, formItem, config, nodeId, props... }) ->

  minValue = config?.minValue

  <InputNumber
    min={minValue}
    disabled={config?.disabled}
    { props... }
  />

export default withRepeater(SequencedFormNumericInput, { selector: (value) -> value })
